import { combineReducers } from 'redux'

import userReducer from "./userReducer";
import formMessageReducer from "./formMessageReducer";


const marvelRootReducer = combineReducers({
    user: userReducer,
    message: formMessageReducer,
});

export default marvelRootReducer;
